const e=(e,o=!1)=>`${e.charAt(0).toUpperCase()}${o?e.slice(1).toLowerCase():e.slice(1)}`;export{e as capitalizeFirstLetter};
